import Vue from 'vue'
import Vuex from 'vuex'
import web from './modules/web'
import config from '../assets/js/config.js'
Vue.use(Vuex)
let state = {
  showLoading: false,
  closeDialog: false,
  message: {},
  page: 1,
  pageSize: 20,
  total: 0,
  serverAddr: config.serverAddr,
  picAddr: config.picAddr,
  changeMediaTypeId: 0,
  secondActiveTab: '',
  firstActiveTab: '0',
  id: 0,
  secondTitle: '',
  sysparam: {}
}
let mutations = {
  apiSuccess (state, body) {
    state.message = {
      message: body.message,
      type: body.success ? 'success' : 'error'
    }
    state.closeDialog = true
  },
  noSelect: (state, opts) => {
    state.message = {
      message: '请选择一行数据',
      type: 'warning' // success/warning/info/error
    }
  },
  alertMsg: (state, opts) => {
    state.message = {
      message: opts.msg,
      type: opts.type // success/warning/info/error
    }
  },
  changePageSize: (state, val) => {
    state.pageSize = val
  },
  changePage: (state, val) => {
    state.page = val
  },
  changeMediaTypeId: (state, opts) => {
    state.changeMediaTypeId = opts
  },
  setSecondActiveTab: (state, opts) => {
    state.secondActiveTab = opts
  },
  setFirstActiveTab: (state, opts) => {
    state.firstActiveTab = opts
  },
  // 末级ID
  changId: (state, opts) => {
    state.id = opts
  },
  changSecondTitle: (state, opts) => {
    state.secondTitle = opts
  }
}
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  modules: {
    web: web
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js